import {Injectable} from '@angular/core';
import {BaseHttpService} from '../../../services/base-http-service.service';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BlogService extends BaseHttpService {
  private ARTICLES = '/blog-posts/';

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getPosts<T>(query: string): Observable<HttpResponse<T>> {
    return this.get(`${this.ARTICLES}${query}`);
  }

  getArticle<T>(id: any): Observable<HttpResponse<T>> {
    return this.get(`${this.ARTICLES}${id}/`);
  }

}
